export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_OUT_OF_HOURS_AUDIT_LOG = 'SET_OUT_OF_HOURS_AUDIT_LOG'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_STANDARD_OPENING_HOURS = 'SET_STANDARD_OPENING_HOURS'
export const SET_HOLIDAY_OPENING_HOURS = 'SET_HOLIDAY_OPENING_HOURS'
export const SET_TENANT_DETAILS = 'SET_TENANT_DETAILS'
export const SET_SELECTED_TENANT = 'SET_SELECTED_TENANT'
export const UPDATE_TENANT_SUPPORT_EMAIL = 'UPDATE_TENANT_SUPPORT_EMAIL'



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/types.js